/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import ConfirmationModal from '@/components/shared/ConfirmationModal'
import {Vue} from 'vue-property-decorator'
import Component from 'vue-class-component'
import UserEditor from '@/components/user/UserEditor'
import {UserService} from '@/services/UserService'
import {UserVO} from '@/valueObjects/UserVO'
import UserServiceMixin from '@/services/UserServiceMixin'
import MessageBox from '@/components/shared/MessageBox'
import {ERROR_MESSAGE_TYPE, SUCCESS_MESSAGE_TYPE} from '@/utils/constants'
import user from '@/store/modules/user'

@Component({
    components: {
        ConfirmationModal,
        MessageBox,
        UserEditor,
    },
    mixins: [UserServiceMixin],
})
export default class UserList extends Vue {
    private modalContent = {
        confirmButtonLabel: 'Delete',
        message: '',
        title: 'Confirm user account removal',
    }
    private message = ''
    private selectedUser: UserVO
    private isConfirmationVisible: boolean = false
    private userService: UserService // redeclared variable to avoid warnings in Webstorm
    private users: object[] = []
    private messageType: string = SUCCESS_MESSAGE_TYPE
    private autoRemoveMessage: boolean = false

    private isCreatingUser: boolean = false
    private isEditingUser: boolean = false
    private isSavingUser: boolean = false

    private way: number = 1

    public mounted() {
        this.loadUsers()
    }

    public async loadUsers(): Promise<void> {
        try {
            this.users = await this.userService.getAll()
        } catch (err) {
            this.message = 'Loading of user list failed. ' + err.errorMessage
            this.messageType = ERROR_MESSAGE_TYPE
            this.autoRemoveMessage = false
        }
    }

    private confirmUserDeletion(user: UserVO) {
        if (user.id === undefined) {
            return this.cancelUserCreation(user)
        }

        this.selectedUser = user
        this.modalContent.message = `You will delete the user account for "${user.email}". This cannot be undone.`
        this.isConfirmationVisible = true
    }

    private cancelUserCreation(user: UserVO) {
        const index = this.users.findIndex((item) => item === user)
        if (index > -1) {
            this.users.splice(index, 1)
        }
        this.isCreatingUser = false
        return
    }

    private cancelModal() {
        this.isConfirmationVisible = false
    }

    private confirmModal() {
        this.isConfirmationVisible = false
        this.deleteSelectedUser()
    }

    private async deleteSelectedUser(): Promise<void> {
        try {
            const email = this.selectedUser.email
            await this.userService.delete(this.selectedUser)
            this.selectedUser = null
            this.users = await this.userService.getAll()
            this.message = `User account ${email} deleted.`
            this.messageType = SUCCESS_MESSAGE_TYPE
            this.autoRemoveMessage = true

        } catch (err) {
            this.message = 'User has not been deleted' + err.errorMessage
            this.messageType = ERROR_MESSAGE_TYPE
            this.autoRemoveMessage = false
        }
    }

    private add() {
        this.isCreatingUser = true
        this.selectedUser = new UserVO(
            '',
            0,
            '',
            '',
            '',
        )
        this.users.push(this.selectedUser)
    }

    private onEditionStarted(user: UserVO) {
        this.isEditingUser = true
        this.selectedUser = user
    }

    private onSave(event: Event) {
        this.isSavingUser = true
    }

    private onSaved(event: Event) {
        this.isEditingUser = false
        this.isCreatingUser = false
        this.loadUsers()
        this.isSavingUser = false
        this.message = 'Modification applied.'
        this.messageType = SUCCESS_MESSAGE_TYPE
        this.autoRemoveMessage = true
    }

    private onError(errorMessage: string) {
        this.message = errorMessage
        this.messageType = ERROR_MESSAGE_TYPE
        this.autoRemoveMessage = false
        this.isEditingUser = false
        this.isCreatingUser = false
        this.isSavingUser = false
    }

    private clearMessage() {
        this.message = ''
    }

    private sort_apk_post(){
        //console.log("Sort by apk number");
        this.users.sort((n1:any,n2:any)=> {
            if(n1.nbApkPost > n2.nbApkPost){
                return -this.way
            }
            if (n1.nbApkPost < n2.nbApkPost){
                return this.way
            }
            return 0
        })
        this.way = this.way *-1
    }
}
